/* eslint-disable */
export default function googleOptimizeInit() {
    if (document.cookie.indexOf('GOOGLE_OPTIMIZE') === -1) return;
    var scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', 'https://www.googleoptimize.com/optimize.js?id=' + env.GOOGLE_OPTIMIZE_KEY);
    document.head.appendChild(scriptTag);
}
